<template>
  <div>
    <router-view v-show="$route.matched.length==3"></router-view>
    <PageHeaderLayout v-show="$route.matched.length==2">
      <div class="main-page-content">
        <el-row class="table-search">
          <el-form :inline="true" :model="searchCondition" class="demo-form-inline">
            <!-- <el-form-item label="ID">
              <el-input v-model="searchCondition.id" placeholder="输入ID" clearable></el-input>
            </el-form-item> -->
            <!-- <el-form-item label="公司名称">
              <el-input v-model="searchCondition.company_name" placeholder="输入公司名称" clearable></el-input>
            </el-form-item> -->
            <el-form-item label="时间">
              <DatePicker @dataSearch="dataSearch"/>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="searchButton">查询</el-button>
            </el-form-item>
          </el-form>
        </el-row>
        <el-row>
          <ScreeCompany @ScreeCompany="ScreeCompany"/>
        </el-row>
        <ApeTable ref="apeTable" :data="wsAccountList" :columns="columns" :loading="loadingStaus" :pagingData="pagingData" @switchPaging="switchPaging" highlight-current-row >
          <el-table-column
            slot="first-column"
            align="center"
            label="公司名称">
            <template slot-scope="scope">
              <el-tooltip class="item" effect="dark" :content="scope.row.uid" placement="top">
                <div>{{ scope.row.company_name }}</div>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column
            slot="first-column"
            prop="money"
            align="center"
            sortable
            label="余额">
            <template slot-scope="scope">
              <div class="tag-group">
                <el-tag type="warning" class="tag-item">
                  <div>账户余额：{{scope.row.balance_money}}</div>
                </el-tag>
                <el-tag type="warning" class="tag-item">
                  <div>充值金额：{{scope.row.recharge_money}}</div>
                </el-tag>
                <el-tag type="warning" class="tag-item">
                  <div>下发金额：{{scope.row.send_money}}</div>
                </el-tag>
                <el-tag type="warning" class="tag-item">
                  <div>税费金额：{{scope.row.tax_money}}</div>
                </el-tag>
              </div>
            </template>
          </el-table-column>
          <el-table-column v-if="buttonType=='text'" align="center" width="250" label="操作">
            <template slot-scope="scope">
              <span>
                <el-button
                  size="mini"
                  type="default"
                  v-if="userPermissions.indexOf('company_rate') != -1"
                  @click="setTaxRate(scope.row.company_id, scope.row.alias_rate)">
                  设置税率
                </el-button>
                <el-button
                  size="mini"
                  type="default"
                  v-if="userPermissions.indexOf('company_recharge') != -1"
                  @click="serviceRecharge(scope.row.id,scope.row.company_id, scope.row.channel_account)"
                >测试服务充值</el-button>
              </span>
            </template>
          </el-table-column>
        </ApeTable>
      </div>
    </PageHeaderLayout>
    <ModalDialog :dialogData="dialogData" @dialogConfirm="handleConfirm" @dialogClose="dialogClose">
      <template slot="content">
        <el-form :model="serviceRechargeData" ref="serviceRechargeForm" label-width="96px">
          <el-form-item label="设置充值金额" prop="taxRate">
            <el-input v-model="serviceRechargeData.money" style="width:200px">
              <template slot="append">元</template>
            </el-input>
          </el-form-item>
        </el-form>
      </template>
    </ModalDialog>
     <el-dialog
      width="25%"
      title="设置税率"
      :before-close="handleOuterClose"
      :visible.sync="outerVisible"
    >
      <el-form :model="taxRateData" label-position="right" label-width="96px">
        <el-form-item label="当前税率">
          <div>{{this.rate}}</div>
        </el-form-item>
        <el-form-item label="设置税率" prop="taxRate">
          <el-input v-model="taxRateData.taxRate" maxlength="4" style="width:200px">
            <template slot="append">%</template>
          </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancelOuter" size="medium">取 消</el-button>
        <el-button
          type="primary"
          @click="checkOuter"
          size="medium"
          :disabled="this.isShowOuterCheckBtn"
        >确定</el-button>
      </div>
    </el-dialog>
  </div >
</template>

<script>
import PageHeaderLayout from '@/layouts/PageHeaderLayout'
import ApeTable from '@/components/ApeTable'
import ApeDrawer from '@/components/ApeDrawer'
import ApeUploader from '@/components/ApeUploader'
import ModalDialog from '@/components/ModalDialog'
import DatePicker from '@/components/DatePicker.vue'
import ScreeCompany from '@/components/ScreeCompany.vue'
import { mapGetters } from 'vuex'

export default {
  components: {
    PageHeaderLayout,
    ApeDrawer,
    ApeTable,
    ApeUploader,
    ModalDialog,
    DatePicker,
    ScreeCompany
  },
  data() {
    return {
      // element的cascader的props值
      cascaderProps:{
        label:'display_name',
        value:'id',
      },
      searchCategory: [],
      // 搜索条件
      searchCondition:{
      },
      loadingStaus: true,
      columns: [
        {
          title: '渠道账号',
          header_align: 'center',
          align: 'center',
          value: 'channel_name',
          // width: 170,
        },
        {
          title: '账号',
          value: 'account',
          header_align: 'center',
          align: 'center',
          // width: 200,
        },
        {
          title: '状态',
          width: 100,
          header_align: 'center',
          align: 'center',
          value: 'status_alias',
        },
        {
          title: '创建时间',
          // width: 250,
          value:'created_at',
          header_align: 'center',
          align: 'center',
        },
        {
          title: '更新时间',
          // width: 250,
          value:'updated_at',
          header_align: 'center',
          align: 'center',
        }
      ],
      // 表格列表数据
      wsAccountList:[],
      // 分页信息
      pagingData:{
        is_show: true,
        layout: 'total, sizes, prev, pager, next, jumper',
        total: 0
      },
      // 分页的offset,序号列使用
      offset:0,
      // 已上传文件列表
      uploadFileList:[],
      // 表单验证
      rules: {
        title: [
          {required: true, message: '输入标题', trigger: 'blur' },
        ],
        type: [
          {required: true, message: '选择类型', trigger: 'blur' },
        ],
        is_new_win: [
          {required: true, message: '选择打开发方式', trigger: 'blur' },
        ],
        is_show: [
          {required: true, message: '选择状态', trigger: 'blur' },
        ],
        image: [
          {required: true, message: '上传图片', trigger: 'blur', validator:this.apeUploaderVerify},
        ],
      },
      dialogData:{
        visible: false,
        title: '',
        width: '25%',
        loading: true,
        modal: false
      },
      serviceRechargeData: {
        money: "",
        id: "",
        company_id: "",
        channel_account: ""
      },
      taxRateData: {
        company_id: "",
        taxRate: "",
      },
      isShowOuterCheckBtn: true, //外层弹窗按钮是否可用
      outerVisible: false, //控制外层弹窗显示/隐藏
      rate: 0,//当前税率
    }
  },
  computed: {
    ...mapGetters(['userPermissions','buttonType'])
  },
  watch: {
    "$route.matched" : function(n,o) {
      console.log(o)
      if (n.length === 2) {
        this.init()
      }
    },
    "taxRateData.taxRate": function(v) {
      if(v) {
        this.isShowOuterCheckBtn = false
      }else {
        this.isShowOuterCheckBtn = true
      }
    },
    "serviceRechargeData.money": function(v) {
      if(v) {
        this.dialogData.loading = false
      } else {
        this.dialogData.loading = true
      }
    }
  },
  methods: {
    /*设置税率*/
    setTaxRate(id, rate) {
      if(rate) {
        this.rate = rate
      }
      this.taxRateData.company_id = id
      this.outerVisible = true;
    },
    //测试服务充值
    serviceRecharge(id, company_id,channel_account) {
      this.dialogData.visible = true
      this.dialogData.title = '测试服务充值'
      this.serviceRechargeData.id = id
      this.serviceRechargeData.company_id = company_id
      this.serviceRechargeData.channel_account = channel_account
    },
    // 处理模态框，确定事件
    handleConfirm() {
      // 调用组件的数据验证方法
      this.$refs['serviceRechargeForm'].validate((valid) => {
        if (valid) {
          if(this.serviceRechargeData.money) {
            this.createRecharge()
          }
        } else {
          this.$message.error('数据验证失败，请检查必填项数据！')
        }
      })
    },
    async createRecharge() {
      let { money, company_id , id, channel_account } = this.serviceRechargeData
      let result = await this.$api.createRecharge(money, channel_account, company_id, id)
      if(result.is_success == 'T') {
        this.dialogData.visible = false
        this.$message({
          showClose: true,
          message: result.memo,
          type: 'success'
        });
        this.serviceRechargeData = {}
        this.init()
      }
    },
    // 处理模态框，关闭事件
    dialogClose() {
      console.log("dialogClose")
      this.serviceRechargeData = {}
      this.dialogData.visible = false
    },
    /*点击外层弹框小×*/
    handleOuterClose() {
      this.outerVisible = false;
      this.taxRateData = {};
    },
    /*取消外层弹窗*/
    cancelOuter() {
      this.outerVisible = false
      this.taxRateData = {};
    },
     /*确定外层弹窗*/
    checkOuter() {
      this.rateFormSubmit()
      this.innerVisible = false;
    },
    // 提交税率表单
    async rateFormSubmit() {
      let company_id = this.taxRateData.company_id,
          rate = this.taxRateData.taxRate
      let result = await this.$api.getRate(company_id, rate)
      if(result) {
        this.$message({
          message: '设置税率成功',
          type: 'success'
        });
        this.init()
      }else {
        this.$message.error('设置税率失败，请稍后重试');
      }
      this.outerVisible = false
      this.taxRateData = {};
    },
    ScreeCompany(v, name) {
      if (name == 'company') {
        if(v) {
          this.searchCondition.company_id = v
        } else {
          delete this.searchCondition.company_id
        }
        this.init('search')
      }

      if(name == 'settlement') {
        if (v) {
          this.searchCondition.channel_account = v
        } else {
          delete this.searchCondition.channel_account
        }
        this.init('search')
      }
    },
    // 搜索
    searchButton() {
      this.init('search')
    },
    // 切换页码操作
    async switchPaging() {
      this.init()
    },
    //获取选中日期的值
    dataSearch(value) {
      this.searchCondition.time_value = value
    },
    // 初始化文章列表
    async init(type) {
      this.loadingStaus=true
      let pagingInfo = this.$refs['apeTable'].getPagingInfo(type)
      if(type == 'search') {
        pagingInfo.current_page = 1
      }
      let searchCondition = this.handleSearchCondition()
      Object.assign(searchCondition,pagingInfo)
      let {list,pages}= await this.$api.getWsAccountList(searchCondition)
      this.wsAccountList = []
      this.$nextTick(() => {
        this.wsAccountList=list
      })
      this.pagingData.total = pages.total
      this.offset = pages.offset
      this.loadingStaus=false
    },
    // 处理搜索条件
    handleSearchCondition() {
      let condition = {}
      if (this.searchCondition.company_name) {
        condition.company_name = this.searchCondition.company_name
      }
      if (this.searchCondition.time_value) {
        condition.start_time = this.searchCondition.time_value[0]
        condition.end_time = this.searchCondition.time_value[1]
      }
      if (this.searchCondition.company_id || this.searchCondition.channel_account) {
        condition.company_id = this.searchCondition.company_id
        condition.channel_account = this.searchCondition.channel_account
      }

      return condition
    }
  },
  mounted() {
    this.init()
  },
}
</script>

<style lang="stylus" scoped>
  .el-button
    margin-right 4px
    margin-bottom 4px
  .table-header
    margin-bottom 12px
  .el-popover .el-checkbox-group .el-checkbox
    margin-left 0px
    margin-right 12px
  .tag-group
    display: flex
    flex-direction: column
  .tag-item
    margin: 5px 0
  .el-tag
    font-size 14px
    line-height 38px
    height 38px
  .money
    font-weight bold
  // .table-search
  //   height: 36px
</style>
